<template>
  <div class="rider-check">
    <div class="banner"></div>

    <div class="form-box">
      <div class="form-tip">
        请填写您领取时使用的信息，系统核对无误后即可显示您的专属口令
      </div>

      <div class="form-item">
        <div class="form-label">
          <img class="label-icon" src="@/assets/eleme/name.png" alt="" />
          <span>姓名</span>
        </div>
        <input
          class="form-input"
          v-model="name"
          type="text"
          maxlength="32"
          placeholder="请输入姓名"
        />
      </div>

      <div class="form-item">
        <div class="form-label">
          <img class="label-icon" src="@/assets/eleme/id.png" alt="" />
          <span>身份证号码</span>
        </div>
        <input
          class="form-input"
          v-model="cardId"
          type="text"
          maxlength="18"
          placeholder="请输入身份证号码"
        />
      </div>

      <div class="form-item">
        <div class="form-label">
          <img class="label-icon" src="@/assets/eleme/tel.png" alt="" />
          <span>联系电话</span>
        </div>
        <input
          class="form-input"
          v-model="phone"
          type="tel"
          maxlength="11"
          placeholder="请输入联系电话"
        />
      </div>

      <button class="submit-btn" @click="onSubmit">查询口令</button>
    </div>

    <!-- 查询成功弹窗 -->
    <van-dialog v-model="showSuccess" :show-confirm-button="false" class="rider-dialog">
      <div class="dialog-body">
        <div class="dialog-text">
          <div>查询成功！</div>
          <div>请复制下面口令，添加客服微信领取通讯大礼包</div>
        </div>
        <div class="dialog-pwd">
          <div class="dialog-pwd-label">口令</div>
          <div class="dialog-pwd-text">{{ pwd }}</div>
          <div class="dialog-copy-btn" @click="copyPwd">复制口令</div>
        </div>
        <div class="dialog-time" v-if="pwdTime">领取时间：{{ pwdTime }}</div>
        <div class="dialog-expire" v-if="validHours > 0">
          该口令 {{ validHours }} 小时内可自助查询，过期后请重新领取
        </div>
        <img class="dialog-qr" src="@/assets/eleme/kefuQRCode.png" alt="客服二维码" />
        <div class="dialog-close" @click="showSuccess = false">关闭</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import { http } from "@/api/http";

export default {
  name: "RiderPwdQuery",
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      name: "",
      cardId: "",
      phone: "",
      showSuccess: false,
      pwd: "",
      pwdTime: "",
      validHours: 0,
      submitting: false,
    };
  },
  methods: {
    async onSubmit() {
      if (this.submitting) return;
      if (!this.name) {
        Toast("请输入姓名");
        return;
      }
      if (!this.cardId) {
        Toast("请输入身份证号码");
        return;
      }
      if (
        !/^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          this.cardId
        )
      ) {
        Toast("请输入正确的身份证号码");
        return;
      }
      if (!this.phone) {
        Toast("请输入联系电话");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        Toast("请输入正确的手机号");
        return;
      }

      this.submitting = true;
      try {
        const res = await http("queryRiderPwd", {
          name: this.name.trim(),
          cardId: this.cardId.trim(),
          phone: this.phone.trim(),
        });

        if (res && res.code === 200) {
          this.pwd = (res.result && res.result.goodsPwd) || "";
          this.pwdTime = (res.result && res.result.createTime) || "";
          this.validHours = (res.result && res.result.validHours) || 0;
          if (!this.pwd) {
            Toast.fail("暂未查询到您的口令，请联系客服");
            return;
          }
          this.showSuccess = true;
        } else {
          Toast.fail({
            message: (res && res.message) || "查询失败，请稍后重试",
            duration: 3500,
          });
        }
      } catch (e) {
        Toast.fail("查询失败，请稍后重试");
      } finally {
        this.submitting = false;
      }
    },
    copyPwd() {
      this.copyText(this.pwd, "口令已复制");
    },
    copyText(text, msg) {
      if (!text) {
        Toast("没有可复制的内容");
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          Toast.success(msg);
        }).catch(() => {
          this.fallbackCopy(text, msg);
        });
      } else {
        this.fallbackCopy(text, msg);
      }
    },
    fallbackCopy(text, msg) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        Toast.success(msg);
      } catch (e) {
        Toast.fail("复制失败");
      }
      document.body.removeChild(textarea);
    },
  },
};
</script>

<style lang="less" scoped>
.rider-check {
  min-height: 100vh;
  background-image: url("~@/assets/eleme/html_bg.jpg");
  background-repeat: no-repeat;
  background-position: top;
  background-size: 100%;
}
.banner {
  height: 30vh;
}
.form-box {
  margin: -40px 20px 0;
  background: #fff;
  border-radius: 24px;
  padding: 24px 24px;
  position: relative;
  z-index: 2;
}
.form-tip {
  font-size: 13px;
  color: #969799;
  line-height: 1.6;
  margin-bottom: 20px;
  text-align: center;
}
.form-item {
  margin-bottom: 24px;
}
.form-label {
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #222;
  margin-bottom: 10px;
  gap: 8px;
}
.label-icon {
  width: 22px;
  height: 22px;
  color: #ff7a3c;
}
.form-input {
  width: 100%;
  height: 48px;
  background-color: #fff8e6;
  border: none;
  border-radius: 999px;
  padding: 0 20px;
  font-size: 16px;
  color: #333;
  box-sizing: border-box;
}
.form-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #ffb88c;
}
.submit-btn {
  width: 100%;
  height: 64px;
  margin-top: 10px;
  background: linear-gradient(90deg, #ff7a3c, #ff4b2b);
  border: 3px solid #fff;
  border-radius: 999px;
  box-shadow: 0 4px 12px rgba(255, 80, 30, 0.35);
  font-size: 26px;
  color: #fff8de;
  font-weight: bold;
}
.submit-btn:active {
  opacity: 0.9;
}

/* 查询结果弹窗 */
.rider-dialog {
  border-radius: 16px;
}
.dialog-body {
  padding: 24px 20px;
  text-align: center;
}
.dialog-text {
  font-size: 16px;
  color: #323233;
  line-height: 1.5;
  margin-bottom: 16px;
}
.dialog-qr {
  width: 160px;
  height: 160px;
  margin: 0 auto 16px;
  display: block;
  object-fit: contain;
}
.dialog-close {
  height: 44px;
  line-height: 44px;
  border-top: 1px solid #f2f3f5;
  color: #576b95;
  font-size: 16px;
}
.dialog-pwd {
  margin: 0 auto 12px;
  text-align: center;
}
.dialog-pwd-label {
  font-size: 13px;
  color: #969799;
  margin-bottom: 4px;
}
.dialog-pwd-text {
  font-size: 16px;
  color: #ff4b2b;
  word-break: break-all;
  padding: 0 12px;
  margin-bottom: 10px;
}
.dialog-copy-btn {
  display: inline-block;
  padding: 6px 22px;
  border-radius: 999px;
  background: #ff7a3c;
  color: #fff;
  font-size: 14px;
}
.dialog-time {
  font-size: 12px;
  color: #969799;
  margin-bottom: 4px;
}

.dialog-expire {
  font-size: 12px;
  color: #ff976a;
  margin-bottom: 12px;
}
</style>
